import { useId } from 'react'

import { useTranslation } from 'react-i18n-lite'

import normalizeFilterRegex from '~/utils/filter/normalizeFilterRegex'

import { SelectionMenuOption } from '../../Selections/SelectionMenu/type'

import { AutocompleteMultiselectionProps } from './type'

type UseFilteredOptionProps = Required<
  Pick<AutocompleteMultiselectionProps, 'options' | 'selectedOptions' | 'value'>
> & {
  collapseSelected: boolean
}

export default function useFilteredOptions({
  options,
  selectedOptions,
  value,
  collapseSelected
}: UseFilteredOptionProps) {
  const selectionTogglerId = useId()

  const { t } = useTranslation()

  const selectionTogglerOption: SelectionMenuOption = {
    id: selectionTogglerId,
    value: `${selectedOptions.length.toString().padStart(2, '0')} ${
      selectedOptions.length === 1
        ? t('multiselection.option-selected')
        : t('multiselection.options-selected')
    }`,
    collapsable: true,
    collapsed: collapseSelected
  }

  const filteredOptions = [
    ...(selectedOptions.length ? [selectionTogglerOption] : []),
    ...options
  ].filter((option) => {
    const isOptionSelected = selectedOptions.some(
      (selectedOption) => selectedOption.value === option.value
    )

    return (
      option.collapsable ||
      (isOptionSelected && !collapseSelected) ||
      (!isOptionSelected &&
        option.value.toLowerCase().match(normalizeFilterRegex(value)))
    )
  })

  return filteredOptions
}
